<template lang="pug">
	.v-partner-and-geo.partner-and-geo(v-if="banner" :class="`partner-and-geo--${banner.color}`")
		.partner-and-geo__container.container
			object.partner-and-geo__image-fp(
				v-if="banner.backgroundStatic"
				type="image/svg+xml"
				:data="banner.backgroundStatic"
				ref="sevRef"
				width="100%"
			)
			object.partner-and-geo__image(
				v-if="banner.background"
				type="image/svg+xml"
				:data="banner.background"
				ref="sevRef"
				width="100%"
			)
			.partner-and-geo__list(v-if="banner.list" )
				.partner-and-geo__list-item(
					v-for="(item, index) in banner.list"
					:key="index"
				)
					.partner-and-geo__list-item_wrap
						.partner-and-geo__list-count {{ `0${index + 1}` }}

						.partner-and-geo__list-text_wrap
							.partner-and-geo__list-title(v-if="item.title") {{ item.title }}
							.partner-and-geo__list-subtitle(v-if="item.subtitle") {{ item.subtitle }}

			.partner-and-geo__wrap
				.partner-and-geo__left
					.partner-and-geo__supertitle(v-if="banner.supertitle")
						v-svg-icon.partner-and-geo__supertitle-icon(:icon="banner.icon || 'flower'")
						.partner-and-geo__supertitle-text {{banner.supertitle}}
					h2.partner-and-geo__title.flc(v-if="banner.title" v-html="banner.title")
				.partner-and-geo__right.content.text-guide(v-if="banner.content" v-html="banner.content")
</template>

<script>
import sourceMixin from '../components/mixins/v-mixin-source.vue';
import isMobMixin from '../components/mixins/v-mixin-is-mob.vue';
import controller from "../scripts/controller/controller.js";
import VBannerGrid from "./v-banner-grid.vue";
import {useRouter} from "vue-router";

export default {
	components: {VBannerGrid},
	mixins: [
		sourceMixin,
		isMobMixin
	],

	data() {
		return {
			banner: null,
			isVisibleBlock: false,
		};
	},

	unmounted() {
		window.removeEventListener('scroll', this.handleScroll);
	},

	mounted() {
		this.currentLogoLink = `/local/assets/images/${this.isVisibleBlock ? 'maps-static' : 'map'}.svg`

		// setTimeout(() => {
		// 	this.playerSvg()
		// 	this.svg.svgatorPlayer.pause()
		// }, 1000)
	},

	methods: {
		handleScroll() {
			const logoHeight = 80;
			const logoOffset = 48;
			if (window.scrollY > this.$el?.offsetTop - 48 && (window.scrollY < this.$el?.offsetHeight + this.$el?.offsetTop + logoHeight - logoOffset)) {
				// document.body.classList.add('state--page-header-blackout');
			}
		},

		playerSvg(targetTime, duration = 500) {

			// console.log('playerSvg', this.$refs['sevRef'], this.$refs['sevRef'].contentDocument.querySelector('svg'));
			this.logoId = this.$refs['sevRef'].contentDocument.querySelector('svg').getAttribute('id');
			this.svg = this.$refs['sevRef'].contentDocument.getElementById(this.logoId);
			// this.svg.svgatorPlayer.set('speed', 1)
			this.player = this.svg && this.svg.svgatorPlayer;
		},

		playSvgAnimation(forward = true) {
			if (!this.player) return;

			const targetDirection = forward ? 1 : -1;

			if (this.player.direction !== targetDirection) {
				this.player.reverse();
				return;
			}

			if (forward) {
				const checkLimit = () => {
					if (this.player.currentTime >= 700) {
						this.player.pause();
						this.player.seek(700);
					} else if (this.player.playbackState === 'playing') {
						requestAnimationFrame(checkLimit);
					}
				};
				requestAnimationFrame(checkLimit);
			}

			this.player.play();
		},

		dataSet(data) {
			this.banner = data;
			this.handleScroll();
			// console.log(data, route.pathname === '/')


			const route = window.location;
			const iconsForMainPage = ['molecule', 'grand', 'handshake', 'buld']
			if (route.pathname === '/') {

				this.banner.items.map((item, index) => {
					item.icon = iconsForMainPage[index];
				});
			}

			window.addEventListener('scroll', this.handleScroll, controller.passiveEventsSupported ? {passive: true} : undefined);
		}
	}
};
</script>
